/**
 * @generated SignedSource<<e13093b9fa2a76afe21f8b6b17c3924e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateClientInput = {
  id: string;
  name?: string | null;
  street?: string | null;
  zip?: string | null;
  city?: string | null;
  vat?: string | null;
  country?: string | null;
  notes?: string | null;
  logoId?: string | null;
  quickbooksCustomerId?: string | null;
  quickbooksCustomerRealmId?: string | null;
  economicCustomerId?: number | null;
  xeroContactId?: string | null;
  salesforceAccountId?: string | null;
  hubspotCompanyId?: string | null;
  pipedriveOrganizationId?: string | null;
  sageIntacctCustomerId?: string | null;
  website?: string | null;
  region?: string | null;
  statusId?: string | null;
  primaryContactId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateClientMutation$variables = {
  input: UpdateClientInput;
};
export type updateClientMutation$data = {
  readonly updateClient: {
    readonly client: {
      readonly id: string;
      readonly name: string;
      readonly street: string | null;
      readonly zip: string | null;
      readonly city: string | null;
      readonly vat: string | null;
      readonly country: string | null;
      readonly notes: string | null;
      readonly logoId: string | null;
      readonly logoDefaultId: number | null;
      readonly quickbooksCustomerId: string | null;
      readonly economicCustomerId: string | null;
      readonly xeroContactId: string | null;
      readonly salesforceAccountId: string | null;
      readonly hubspotCompanyId: string | null;
      readonly pipedriveOrganizationId: string | null;
      readonly sageIntacctCustomerId: string | null;
    } | null;
  } | null;
};
export type updateClientMutation = {
  variables: updateClientMutation$variables;
  response: updateClientMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateClientPayload",
    "kind": "LinkedField",
    "name": "updateClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Client",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "street",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "zip",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "city",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "country",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "logoDefaultId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quickbooksCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "economicCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xeroContactId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesforceAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hubspotCompanyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pipedriveOrganizationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sageIntacctCustomerId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateClientMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateClientMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b3fb8757f199e6a4ca140c5054dd45a",
    "id": null,
    "metadata": {},
    "name": "updateClientMutation",
    "operationKind": "mutation",
    "text": "mutation updateClientMutation(\n  $input: UpdateClientInput!\n) {\n  updateClient(input: $input) {\n    client {\n      id\n      name\n      street\n      zip\n      city\n      vat\n      country\n      notes\n      logoId\n      logoDefaultId\n      quickbooksCustomerId\n      economicCustomerId\n      xeroContactId\n      salesforceAccountId\n      hubspotCompanyId\n      pipedriveOrganizationId\n      sageIntacctCustomerId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "69946406b7b2271a1229abd5b60b3147";

export default node;
